import React, { useState, useEffect } from 'react';

const ReferralPanel = ({ plan, hasGenerated }) => {
  const [referralData, setReferralData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchReferral = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const res = await fetch('/api/referral/code', {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        if (res.ok) {
          const data = await res.json();
          setReferralData(data);
        }
      } catch(e) {}
      setLoading(false);
    };
    if (hasGenerated) fetchReferral();
    else setLoading(false);
  }, [hasGenerated]);

  const copyLink = () => {
    if (referralData && referralData.link) {
      navigator.clipboard.writeText(referralData.link).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  };

  const shareText = 'I use VlogClip AI to turn YouTube videos into TikTok clips — try it free:';

  const shareOnTwitter = () => {
    if (!referralData) return;
    const url = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(shareText + ' ' + referralData.link);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const shareOnWhatsApp = () => {
    if (!referralData) return;
    const url = 'https://wa.me/?text=' + encodeURIComponent(shareText + ' ' + referralData.link);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (!hasGenerated) {
    return (
      <div style={{textAlign:'center',padding:'20px'}}>
        <div style={{fontSize:'32px',marginBottom:'8px'}}>{'🎁'}</div>
        <p style={{color:'#94a3b8',fontSize:'13px',marginBottom:'12px'}}>Generate your first clip to unlock the referral program</p>
        <p style={{color:'#64748b',fontSize:'12px'}}>Earn extra video credits for every friend you refer!</p>
      </div>
    );
  }

  if (loading) return <div style={{padding:'16px',textAlign:'center',color:'#64748b'}}>Loading...</div>;

  const isPaid = plan === 'pro' || plan === 'business';

  return (
    <div>
      <div style={{padding:'14px',background:'rgba(99,102,241,0.08)',borderRadius:'12px',border:'1px solid rgba(99,102,241,0.15)',marginBottom:'14px'}}>
        <div style={{color:'#94a3b8',fontSize:'11px',fontWeight:'600',marginBottom:'6px',textTransform:'uppercase',letterSpacing:'0.5px'}}>Your Referral Link</div>
        <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
          <div style={{flex:1,padding:'8px 12px',background:'rgba(0,0,0,0.2)',borderRadius:'8px',fontSize:'12px',color:'#e2e8f0',fontFamily:'monospace',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
            {referralData ? referralData.link : 'Loading...'}
          </div>
          <button onClick={copyLink} style={{padding:'8px 16px',borderRadius:'8px',border:'none',background: copied ? '#10b981' : 'linear-gradient(135deg,#8b5cf6,#06b6d4)',color:'#fff',fontSize:'12px',fontWeight:'700',cursor:'pointer',whiteSpace:'nowrap',transition:'all 0.2s'}}>
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <div style={{marginTop:'8px',color:'#64748b',fontSize:'11px'}}>
          Code: <span style={{color:'#a78bfa',fontWeight:'700',fontFamily:'monospace'}}>{referralData ? referralData.code : '...'}</span>
        </div>
      </div>

      {/* Share Buttons */}
      <div style={{display:'flex',gap:'8px',marginBottom:'14px'}}>
        <button onClick={shareOnTwitter} style={{flex:1,padding:'10px',borderRadius:'10px',border:'1px solid rgba(29,161,242,0.2)',background:'rgba(29,161,242,0.08)',color:'#1da1f2',fontSize:'12px',fontWeight:'700',cursor:'pointer',transition:'all 0.2s'}}>
          Share on X
        </button>
        <button onClick={shareOnWhatsApp} style={{flex:1,padding:'10px',borderRadius:'10px',border:'1px solid rgba(37,211,102,0.2)',background:'rgba(37,211,102,0.08)',color:'#25d366',fontSize:'12px',fontWeight:'700',cursor:'pointer',transition:'all 0.2s'}}>
          Share on WhatsApp
        </button>
      </div>

      <div style={{display:'flex',gap:'10px',marginBottom:'14px',flexWrap:'wrap'}}>
        <div style={{flex:1,minWidth:'80px',padding:'12px',background:'rgba(255,255,255,0.03)',borderRadius:'10px',textAlign:'center',border:'1px solid rgba(255,255,255,0.06)'}}>
          <div style={{color:'#fff',fontSize:'22px',fontWeight:'800'}}>{referralData ? referralData.referrals : 0}</div>
          <div style={{color:'#64748b',fontSize:'10px',fontWeight:'600',textTransform:'uppercase',marginTop:'2px'}}>Referrals</div>
        </div>
        <div style={{flex:1,minWidth:'80px',padding:'12px',background:'rgba(255,255,255,0.03)',borderRadius:'10px',textAlign:'center',border:'1px solid rgba(255,255,255,0.06)'}}>
          <div style={{color:'#10b981',fontSize:'22px',fontWeight:'800'}}>+{referralData ? referralData.creditsEarned : 0}</div>
          <div style={{color:'#64748b',fontSize:'10px',fontWeight:'600',textTransform:'uppercase',marginTop:'2px'}}>Credits Earned</div>
        </div>
      </div>
      <div style={{padding:'10px 12px',background:'rgba(255,255,255,0.02)',borderRadius:'8px',border:'1px solid rgba(255,255,255,0.04)'}}>
        <div style={{color:'#94a3b8',fontSize:'11px',fontWeight:'700',marginBottom:'6px'}}>How it works</div>
        <div style={{color:'#64748b',fontSize:'11px',lineHeight:'1.6'}}>
          1. Share your referral link with friends<br/>
          2. They sign up using your link<br/>
          3. You both get {isPaid ? '2 extra video credits' : '1 extra video credit'}
        </div>
      </div>
    </div>
  );
};

export default ReferralPanel;
